import * as styles from "/tools/js/svg/templates/svg.module.scss";
const SvgGoogleBusinessProfileLogo = ({ title, titleId, ...props }) => {
  props = Object.assign({}, props, {
    "aria-hidden": true,
  });
  if (!props.noAlign) {
    const className = (props.className || "") + " " + styles.alignIcon;
    props = Object.assign({}, props, {
      className,
    });
  }
  return (
    <svg
      width={24}
      height={24}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-labelledby={titleId}
      {...props}
    >
      {title ? <title id={titleId}>{title}</title> : null}
      <path
        d="M18.696 8.032H4.884a.594.594 0 0 0-.594.594v10.028c0 .328.266.594.594.594h13.812a.594.594 0 0 0 .594-.594V8.626a.594.594 0 0 0-.594-.594Z"
        fill="#4989F5"
      />
      <path
        d="M18.522 7.95H5.04c-.417 0-.742 3.231-.742 3.649l7.383 7.65h6.84a.762.762 0 0 0 .76-.759V8.708a.762.762 0 0 0-.76-.759Z"
        fill="url(#src__com__yext__listingslaunchstorm__public__icons__google-business-profile-logo_svg__a)"
      />
      <path d="M7.715 9.911H12V4.286H8.357l-.642 5.625Z" fill="#3C4BA6" />
      <path
        d="M16.286 9.911H12V4.286h3.644l.642 5.625ZM19.306 5.353l.02.06c-.005-.02-.015-.04-.02-.06Z"
        fill="#7BABF7"
      />
      <path
        d="m19.295 5.372-.005-.02a1.356 1.356 0 0 0-1.324-1.066h-2.322l.642 5.625h4.285l-1.276-4.54Z"
        fill="#3F51B5"
      />
      <path d="m4.742 5.353-.02.06c.005-.02.014-.04.02-.06Z" fill="#7BABF7" />
      <path
        d="m4.706 5.372.005-.02a1.355 1.355 0 0 1 1.324-1.066h2.322l-.643 5.625H3.43l1.277-4.54Z"
        fill="#7BABF7"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7.722 9.91a2.142 2.142 0 1 1-4.284 0h4.284Z"
        fill="#709BE0"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12.005 9.91a2.142 2.142 0 0 1-4.283 0h4.283Z"
        fill="#3C4BA6"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M16.288 9.91a2.142 2.142 0 0 1-4.283 0h4.283Z"
        fill="#709BE0"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M20.571 9.91a2.142 2.142 0 0 1-4.283 0h4.283Z"
        fill="#3C4BA6"
      />
      <path
        d="M18.43 15.712a4.066 4.066 0 0 0-.038-.314h-2.336c0 .327 0 .683-.002 1.01h1.354c-.058.308-.237.58-.496.756v-.006a1.417 1.417 0 0 1-.549.214 1.48 1.48 0 0 1-1.145-.242 1.543 1.543 0 0 1-.568-.76v-.003l.003-.002a1.5 1.5 0 0 1-.001-.964c.075-.22.197-.42.36-.585a1.46 1.46 0 0 1 1.47-.383c.201.062.385.17.536.315l.457-.457c.08-.08.164-.16.241-.244a2.412 2.412 0 0 0-.8-.495 2.514 2.514 0 0 0-1.729.005 2.5 2.5 0 0 0-1.566 1.836 2.485 2.485 0 0 0 1.791 2.89c.414.11.854.108 1.271.013.38-.085.73-.267 1.018-.528.3-.277.515-.645.628-1.036.094-.331.128-.677.1-1.02Z"
        fill="#fff"
      />
      <defs>
        <linearGradient
          id="src__com__yext__listingslaunchstorm__public__icons__google-business-profile-logo_svg__a"
          x1={4.298}
          y1={13.599}
          x2={19.281}
          y2={13.599}
          gradientUnits="userSpaceOnUse"
        >
          <stop offset={0.03} stopColor="#4079D8" />
          <stop offset={1} stopColor="#4989F5" />
        </linearGradient>
      </defs>
    </svg>
  );
};
export default SvgGoogleBusinessProfileLogo;
